import { Button, ButtonGroup } from "@chakra-ui/react";
import { useNavigate } from "react-router-dom";
import { useAppSelector } from "../../../store/hooks";

export const Header = () => {
  const navigate = useNavigate();
  const { isAuthenticated } = useAppSelector((state) => state.auth);

  return (
    <header className="flex items-center justify-between py-6!">
      <img src="assets/logo/logo.svg" alt="Logo" className="w-24" />

      <ul className="hidden md:flex items-center gap-8">
        {[
          { label: "About", href: "#about" },
          { label: "How it works", href: "#how-it-works" },
          { label: "FAQ", href: "#faq" },
          { label: "Contact", href: "#contact" },
        ].map((item) => (
          <li key={item.label}>
            <a
              className="text-sm! text-[#605F5F]! font-medium! hover:text-blue-700! transition"
              href={item.href}>
              {item.label}
            </a>
          </li>
        ))}
      </ul>

      <ButtonGroup spaceX="3">
        {isAuthenticated ? (
          <Button
            onClick={() => navigate("/dashboard")}
            variant="solid"
            color="white"
            bg="blue.700"
            _hover={{ bg: "blue.800" }}
            size="sm">
            Dashboard
          </Button>
        ) : (
          <>
            <Button
              onClick={() => navigate("/login")}
              variant="outline"
              color="blue.700"
              borderColor="blue.700"
              size="sm">
              Login
            </Button>

            <Button
              onClick={() => navigate("/register")}
              variant="solid"
              color="white"
              bg="blue.700"
              _hover={{ bg: "blue.800" }}
              size="sm">
              Sign up
            </Button>
          </>
        )}
      </ButtonGroup>
    </header>
  );
};
